import { useQuery } from '@tanstack/react-query';
import { IKeepInTouchScore } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouch/scores/byContact';

export function useKeepInTouchScoresByContact({ contactId, enabled = true }: { contactId: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!contactId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchScore[]>(
				`keepInTouch/scores/byContact/${encodeURIComponent(contactId)}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, contactId],
		meta: {
			toastErrorMessage: 'Failed to load contact scores',
		},
	});
}

export const invalidateKeepInTouchScoresByContact = (contactId?: string) => {
	reactQueryClient.invalidateQueries({ queryKey: contactId ? [BASE_QUERY_KEY, contactId] : [BASE_QUERY_KEY] });
};
